// export function getPriceForQuantity(priceTiers, quantity) {
//   if (!priceTiers || priceTiers.length === 0) return null;

//   // Sortiramo da budemo sigurni (najveći min_quantity prvi)
//   const sortedTiers = [...priceTiers].sort(
//     (a, b) => b.min_quantity - a.min_quantity
//   );

//   for (let tier of sortedTiers) {
//     if (quantity >= tier.min_quantity) {
//       return parseFloat(tier.price);
//     }
//   }
//   // Ako ništa ne odgovara, uzmi najskuplju
//   return parseFloat(sortedTiers[sortedTiers.length - 1].price);
// }

export function getPriceForQuantity(priceInfo, quantity) {
  if (!priceInfo || typeof priceInfo.price !== "number") {
    return null;
  }
  return priceInfo.price;
}
